export const goAnim = (animatedElementsClass) => {
    const animatedElements = document.querySelectorAll(`.${animatedElementsClass}`)
    const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('go-anim')
                obs.unobserve(entry.target)
            }
        })
    }, {
        threshold: 0.1,
    })

    animatedElements.forEach(element => observer.observe(element))
}
